var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLockBgTransparent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26C0 11.6406 11.6406 0 26 0C40.3594 0 52 11.6406 52 26C52 40.3594 40.3594 52 26 52C11.6406 52 0 40.3594 0 26Z",
    fill: "#D92D20",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 22.6667H32.6667C33.1269 22.6667 33.5 23.0398 33.5 23.5V33.5C33.5 33.9603 33.1269 34.3334 32.6667 34.3334H19.3333C18.8731 34.3334 18.5 33.9603 18.5 33.5V23.5C18.5 23.0398 18.8731 22.6667 19.3333 22.6667H21V21.8334C21 19.0719 23.2386 16.8334 26 16.8334C28.7614 16.8334 31 19.0719 31 21.8334V22.6667ZM25.1667 29.1104V31H26.8333V29.1104C27.3315 28.8222 27.6667 28.2836 27.6667 27.6667C27.6667 26.7462 26.9205 26 26 26C25.0795 26 24.3333 26.7462 24.3333 27.6667C24.3333 28.2836 24.6685 28.8222 25.1667 29.1104ZM29.3333 22.6667V21.8334C29.3333 19.9924 27.8409 18.5 26 18.5C24.159 18.5 22.6667 19.9924 22.6667 21.8334V22.6667H29.3333Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLockBgTransparent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LockBGTransparent.f073f80e.svg";
export { ForwardRef as ReactComponent };